import Vue from 'vue'
import master from '../masterModules/masterMutation.js'
// device-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearDevice(store, payload) {
    store.commit('clearDevice', payload)
  },
  changePersonalDeviceFlag(store, payload) {
    store.commit('changePersonalDeviceFlag', payload)
  },
  updateSelectedDeviceList(store, payload) {
    store.commit('updateSelectedDeviceList', payload)
  },
  clearSelectedDeviceList(store) {
    store.commit('clearSelectedDeviceList')
  },
  async addDevice(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization,
        timeout: 1000 * 300
      }
    }
    const data = {
      header,
      data: [
        {
          devices: [store.state.addDevice]
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/device/regist', data, config)
    // 成功
    // 追加後の処理
    // store.commit('setDevices', response)
  },
  async setDevices(store, payload) {
    store.state.devices = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          devices: [],
          pageNo: payload.pageNo,
          count: 20,
          searchWord: payload.searchWord
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/device/list',
      data,
      config
    )
    // 成功
    store.commit('setDevices', response)
  },
  async updateDevice(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          devices: [store.state.updateDevice]
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/device/update', data, config)
    // 成功
    // 更新後の処理
    // store.commit('setDevices', response)
  },
  async deleteDevices(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          devices: payload
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/device/delete', data, config)
    // 成功
    // 削除後の処理
    // store.commit('setDevices', response)
  },
  async setDetailDevice(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          devices: [
            {
              deviceId: payload.deviceId
            }
          ]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/device/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async importDevices(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 3000
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            devices: payload.slice(pageNo * count, pageNo * count + count),
            startFlag: pageNo === 0,
            endFlag: false
          }
        ]
      }

      const size = payload.length
      pageNo++
      if (size <= pageNo * count) {
        data.data[0].endFlag = true
        logContinue = false
      }

      await Vue.http.post(URL + '/v2/admin/device/import', data, config)
    }

    // 成功
    // 追加後の処理
    // store.commit('setDevices', response)
  },
  async setExportData(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 3000
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    let totalCount = 0
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: payload.selectedDeviceIdList.slice(
          pageNo * count,
          pageNo * count + count
        ),
        pageNo: payload.selectedDeviceIdList.length === 0 ? pageNo : 0,
        count: count,
        searchWord: payload.searchWord
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/device/export',
        data,
        config
      )

      const size = response.data['data'].length
      totalCount += size
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
      if (payload.selectedDeviceIdList.length > 0 && totalCount >= payload.selectedDeviceIdList.length) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }

    // 成功
    // 追加後の処理
    store.commit('setExportData', margeData)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/deviceModules/actions.js